import styled from "styled-components"
import { medScreen } from "../../Responsive"

export const Wrapper = styled.button`
  display: block;
  background: var(--primary);
  width: ${props => props.width}%;
  min-width: 150px;
  height: 50px;
  border-radius: 5px;
  color: var(--darkGrey);
  border: 0;
  font-size: var(--fontM);
  margin: 20px auto;
  transition: all 0.5s ease;
  outline: none;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }

  &:disabled {
    color: var(--lightGrey);
    cursor: not-allowed;
  }

  @media screen and (max-width: ${medScreen}) {
    font-size: var(--fontS);
  }
`